import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["toggle", "inputs"]

    connect() {
        // Set initial state based on checkbox on page load
        this.updateVisibility()
    }

    toggle(event) {
        // For click event, we need to wait for the browser to update the checkbox
        // Using requestAnimationFrame ensures the checkbox state has been updated
        requestAnimationFrame(() => {
            this.updateVisibility()
        })
    }

    updateVisibility() {
        if (this.hasToggleTarget && this.hasInputsTarget) {
            if (this.toggleTarget.checked) {
                this.inputsTarget.classList.remove("hidden")
            } else {
                this.inputsTarget.classList.add("hidden")
            }
        }
    }
}
